
<div *ngIf="checkmobile() && print" class="marging-bottom-10">
    <button type="button" (click)="printFile()"><i class="fa fa-print"></i></button>
  </div>

<ngx-extended-pdf-viewer
  #innerViewer
  [src]="_pdfSrc"
  [height]="'100%'"
  [showDownloadButton]="download?'always-visible':false"
  [showPrintButton]="print?'always-visible':false"
  [enablePrint]="!checkmobile()"
  [showOpenFileButton]="false"
  [showPresentationModeButton]="false"
  [showZoomButtons]="true"
  [showSecondaryToolbarButton]="false"
  [showHandToolButton]="false"
  [handTool]="false"
  [showSpreadButton]="false"
  [showPropertiesButton]="true"
  [showBorders]="false"
  [textLayer]="true"
  [showDrawEditor]="false"
  [showStampEditor]="false"
  [showTextEditor]="false"
  [showHighlightEditor]="false"
  [showPagingButtons]="false"
  [filenameForDownload]="downloadFileName || derivedName"
  [showSidebarButton]="sidebar"
  style="width:100%;height:100%;">
</ngx-extended-pdf-viewer>
